import { toFixedNumber } from 'shared/utils';
import timeChartDataMock4 from './4.json';
import timeChartDataMock6 from './6.json';
import { TimeseriesChartItem } from '../types';

export const TimeseriesChartDataMock: TimeseriesChartItem[] = [
  {
    name: '99%',
    data: timeChartDataMock6.map(({ PnL, dateTime }) => {
      const formatedDate = new Date(dateTime).getTime();
      return [formatedDate, toFixedNumber(parseFloat(PnL), 2)];
    }),
  },
];

export const TimeserieChartVar99DataMock: TimeseriesChartItem[] = [
  {
    name: '99%',
    data: timeChartDataMock6.map(({ dateTime, var99 }) => {
      const formatedDate = new Date(dateTime).getTime();
      return [formatedDate, toFixedNumber(parseFloat(var99), 2)];
    }),
  },
];

export const TimeserieChartDataMockSingle: TimeseriesChartItem = {
  name: 'Single',
  data: timeChartDataMock4,
};

export const MultipleSelectionChartMock: TimeseriesChartItem[] = [
  {
    name: 'EME Real',
    marker: { symbol: 'circle', enabled: false },
    color: '#00A45D',
    type: 'line',
    data: [
      [Date.UTC(1970, 10, 25), 2.2],
      [Date.UTC(1970, 11, 6), 2.2],
      [Date.UTC(1970, 11, 20), 2.4],
      [Date.UTC(1970, 11, 25), 2.4],
      [Date.UTC(1971, 0, 4), 2.5],
      [Date.UTC(1971, 0, 17), 2.6],
      [Date.UTC(1971, 0, 24), 2.3],
      [Date.UTC(1971, 1, 4), 1.5],
      [Date.UTC(1971, 1, 14), 1.6],
      [Date.UTC(1971, 2, 6), 1.2],
      [Date.UTC(1971, 2, 14), 1.1],
      [Date.UTC(1971, 2, 24), 1],
    ],
  },
  {
    name: 'EME Predicted',
    marker: { symbol: 'circle', enabled: false },
    color: '#00A45D',
    type: 'line',
    dashStyle: 'Dash',
    lineWidth: 1,
    data: [
      [Date.UTC(1970, 10, 25), 2.3],
      [Date.UTC(1970, 11, 6), 2],
      [Date.UTC(1970, 11, 20), 2.7],
      [Date.UTC(1970, 11, 25), 2.5],
      [Date.UTC(1971, 0, 4), 2.1],
      [Date.UTC(1971, 0, 17), 2.2],
      [Date.UTC(1971, 0, 24), 1.3],
      [Date.UTC(1971, 1, 4), 1.4],
      [Date.UTC(1971, 1, 14), 1.2],
      [Date.UTC(1971, 2, 6), 1.1],
      [Date.UTC(1971, 2, 14), 0.9],
      [Date.UTC(1971, 2, 24), 1.1],
    ],
  },
  {
    name: 'EPE Real',
    marker: { symbol: 'circle', enabled: false },
    color: '#EE2F53',
    type: 'line',
    data: [
      [Date.UTC(1970, 10, 25), -2.0],
      [Date.UTC(1970, 11, 6), -2.25],
      [Date.UTC(1970, 11, 20), -2.41],
      [Date.UTC(1970, 11, 25), -2.64],
      [Date.UTC(1971, 0, 4), -2.6],
      [Date.UTC(1971, 0, 17), -2.55],
      [Date.UTC(1971, 0, 24), -1.62],
      [Date.UTC(1971, 1, 4), -0.5],
      [Date.UTC(1971, 1, 14), -0.42],
      [Date.UTC(1971, 2, 6), -0.2],
      [Date.UTC(1971, 2, 14), -0.1],
      [Date.UTC(1971, 2, 24), 0],
    ],
  },
  {
    name: 'EPE Predicted',
    marker: { symbol: 'circle', enabled: false },
    color: '#EE2F53',
    type: 'line',
    dashStyle: 'Dash',
    lineWidth: 1,
    data: [
      [Date.UTC(1970, 10, 25), -1.0],
      [Date.UTC(1970, 11, 6), -1.25],
      [Date.UTC(1970, 11, 20), -1.41],
      [Date.UTC(1970, 11, 25), -1.64],
      [Date.UTC(1971, 0, 4), -1.6],
      [Date.UTC(1971, 0, 17), -1.55],
      [Date.UTC(1971, 0, 24), -1.62],
      [Date.UTC(1971, 1, 4), -1.5],
      [Date.UTC(1971, 1, 14), -1.42],
      [Date.UTC(1971, 2, 6), -1.2],
      [Date.UTC(1971, 2, 14), -1.1],
      [Date.UTC(1971, 2, 24), -1],
    ],
  },
];
